import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=c4ade99a&scoped=true&"
import script from "./VideoMonitor.vue?vue&type=script&lang=js&"
export * from "./VideoMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VideoMonitor.vue?vue&type=style&index=0&id=c4ade99a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ade99a",
  null
  
)

export default component.exports